import styled from 'styled-components';

export const Container = styled.div`
  height: calc(100vh - 170px);
  overflow: hidden;
  position: relative;
  padding-top: 50px;
`;

export const TabsContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 16px 0 0;
  background: #fff;
  gap: 24px;
  width: 100%;
  display: flex;
  overflow-x: scroll;
  scrollbar-width: none;
`;

export const Tab = styled.div<{ active: boolean }>`
  border-bottom: ${({ active }) => (active ? '3px solid #C18244' : 'none')};
  color: ${({ active }) => (active ? '#1C1C1C' : '#52525B')};
  font-size: 16px;
  line-height: 1.2;
  font-weight: 500;
  cursor: pointer;
  padding-bottom: 11px;
  flex-shrink: 0;
`;

export const ContentContainer = styled.div`
  overflow-y: scroll;
  height: 100%;
  scrollbar-width: none;
`;

export const Section = styled.div`
  padding-top: 24px;
`;
